<template>
  <Box>
    <BoxHead icon="fas fa-receipt">
      Accounts & Investments
    </BoxHead>

    <BoxLoader v-if="loading" />

    <EmptySection
      v-else-if="isEmpty"
      :badges="['Assets']"
    />

    <template
      v-else
    >
      <Callout
        status="danger"
        icon-before="fas fa-exclamation-triangle"
      >
        Add Benificiaries to Roth IRA
      </Callout>

      <DataTable
        :head="accountsTable.head"
        :body="accountsTable.body"
        :foot="accountsTable.foot"
      />

      <DetailsTitle
        icon="fas fa-coins"
        value="$123,738"
      >
        Total Accounts & Investments
      </DetailsTitle>
    </template>
  </Box>
</template>

<script setup>
import { computed } from 'vue';
import { Box, BoxHead, BoxLoader, Callout, DataTable, DetailsTitle } from '@stakeui';
import { formatCurrency } from '@frontend/shared/Util.js';
import EmptySection from './EmptySection.vue';
import { isEmptyValue } from '@frontend/shared/Util.js';

const props = defineProps({
  client: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const accounts = computed(() => props.client?.accounts);
const isEmpty = computed(() => isEmptyValue(accounts.value));

const accountsTable = computed(() => {
  if (!accounts?.value) {
    return {};
  }

  const body = accounts.value.map((account, index) => ({
    id: 'checking',
    cells: [
      { id: 'name', label: account.name },
      { id: 'account-type', label: account.type },
      { id: 'institution', label: account.institution },
      { id: 'alerts', label: account.alert },
      { id: 'value', label: formatCurrency(account.value), type: 'numeric' },
    ],
  }
  ));

  return {
    head: [
      { id: 'name', label: 'Name' },
      { id: 'account-type', label: 'Account Type' },
      { id: 'institution', label: 'Institution' },
      { id: 'alerts', label: 'Alerts' },
      { id: 'value', label: 'Value' },
    ],
    body,
  };
});
</script>
